/**
 * Client route paths.
 * Convention: lowercase; multi-word segments use kebab-case (e.g. /order-history).
 */

export const PATHS = {
  home: '/',
  venues: '/venues',
  caterers: '/caterers',
  decorators: '/decorators',
  photographers: '/photographers',
  payment: '/payment',
  orderConfirmation: '/order-confirmation',
  orderHistory: '/order-history',
  orderDetail: '/order-detail',
  profile: '/profile',
  contactUs: '/contact-us',
  faqs: '/faqs',
  writeReview: '/write-review',
  reviewSuccess: '/review-success',
  helpMain: '/help-main',
  helpCenter: '/help-main/help-center',
  termsAndConditions: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  verify: '/verify',
  verifyMobileNumber: '/verify-mobile-number',
  verificationSuccess: '/verification-success',
  accountRegister: '/account-register',
  resetPassword: '/reset-password',
  favorite: '/favorite',
};

/**
 * Former camelCase / concatenated paths → canonical kebab-case.
 * Used for <Navigate replace> so bookmarks and emailed links keep working.
 */
export const LEGACY_PATH_REDIRECTS = [
  { from: '/orderDetail', to: PATHS.orderDetail },
  { from: '/orderconfirmation', to: PATHS.orderConfirmation },
  { from: '/termsAndConditions', to: PATHS.termsAndConditions },
  { from: '/privacyPolicy', to: PATHS.privacyPolicy },
  { from: '/verifyMobileNumber', to: PATHS.verifyMobileNumber },
  { from: '/verificationSuccess', to: PATHS.verificationSuccess },
  { from: '/accountRegister', to: PATHS.accountRegister },
  { from: '/resetpassword', to: PATHS.resetPassword },
  { from: '/FAQs', to: PATHS.faqs },
];

export const LEGACY_HELP_CENTER_PREFIX = '/help-main/helpCenter';
